export const colorVariables = {
  green: "#D0FBE3",
  white: "#FFFFFF",
  red: "#e6004c",
  gray: "#D9D9D98A",
  grayText: "#3333338F",
  black: "#333333",
  marron: "#544E4E",
  gradient_primary:
    "linear-gradient(90deg,rgba(12, 192, 190, 1) 23%, rgba(118, 227, 163, 1) 86%)",
  primary: "#0CC0BE",
  secondary: "#7ED4AD",
  darkGreen: "#6DAB93",
  lightWhite: "#F8FAFC",
  orange: "#FF5733",
  blue: "#0047AB",
  violet: "#DBEAFF",
  darkViolet: "#617EC6",
  disabledColor: "#000",
  disabledBg: "#F5F5F5",
  disabledOpacity: 0.6,
  selectedRow: "#e6e6e6",
  lightGray: "#eee",
  redLight: "#FFE6E6",
};

type TCustomValue = {
  borderRadius: number;
  chipRadius: number;
  chipVariant: "outlined" | "filled";
  buttonVariant: "text" | "outlined" | "contained";
};
export const customValue: TCustomValue = {
  borderRadius: 1,
  chipRadius: 5,
  chipVariant: "outlined",
  buttonVariant: "outlined",
};

// export const TEXT_LENGTH = 100;
